// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label.el-checkbox[data-v-741cc264]{padding-right:10px}", ""]);
// Exports
module.exports = exports;
